import React from 'react';
import { Link } from 'react-router-dom';
import { useApp } from '../../context/AppContext';  // Fixed path: ../../ instead of ../

const Navbar = () => {
    const { sections } = useApp();

    // Map section IDs to navbar items
    const sectionToNavItem = {
        'politics': { name: 'Politics', path: '/category/politics' },
        'business': { name: 'Business', path: '/category/business' },
        'sports': { name: 'Sports', path: '/category/sports' },
        'entertainment': { name: 'Entertainment', path: '/category/entertainment' },
        'technology': { name: 'Technology', path: '/category/technology' },
        'videos': { name: 'Videos', path: '/videos' },
        'jokes': { name: 'Jokes', path: '/jokes' }
    };

    // Always show these items regardless of section settings
    const alwaysShow = [
        { name: 'Home', path: '/' },
        { name: 'India', path: '/category/india' },
        { name: 'World', path: '/category/world' }
    ];

    // Get enabled sections from database
    const enabledSections = sections?.filter(s => s.enabled === true) || [];

    // Build dynamic categories based on enabled sections
    const dynamicCategories = enabledSections
        .map(section => sectionToNavItem[section.id])
        .filter(item => item !== undefined);

    // Combine always-show items with dynamic sections
    const categories = [...alwaysShow, ...dynamicCategories];

    return (
        <nav style={{ background: 'var(--navy)' }}>
            <div className="inner" style={{ maxWidth: '1280px', margin: 'auto', display: 'flex', alignItems: 'center', overflowX: 'auto' }}>
                {categories.map((cat, idx) => (
                    <Link
                        key={idx}
                        to={cat.path}
                        style={{
                            color: '#dde',
                            padding: '12px 16px',
                            fontSize: '13px',
                            fontWeight: '600',
                            letterSpacing: '0.5px',
                            whiteSpace: 'nowrap',
                            transition: 'background 0.2s',
                            textDecoration: 'none'
                        }}
                        onMouseEnter={(e) => e.target.style.background = 'var(--red)'}
                        onMouseLeave={(e) => e.target.style.background = 'transparent'}
                    >
                        {cat.name}
                    </Link>
                ))}
                {/* <Link to="/live-tv" style={{
                    background: 'var(--red)',
                    color: '#fff',
                    padding: '12px 16px',
                    fontSize: '13px',
                    fontWeight: '600',
                    marginLeft: 'auto',
                    whiteSpace: 'nowrap',
                    textDecoration: 'none'
                }}>
                    <span style={{ animation: 'blink 1s infinite' }}>● </span>LIVE TV
                </Link> */}
            </div>
        </nav>
    );
};

export default Navbar;